import DomComponent from './dom-component.js';


export default class ListManagerComponent extends DomComponent
{

	constructor(settings = {}) 
	{
		super(settings);
	}

	setManager(manager)
	{
		this.manager = manager;
	
		return this;
	}

}